module.exports = __webpack_public_path__ + "logo.png?e8fec2ef0b52be5402c3dd3b436709da";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 1236
// module chunks = 27